// Pure terminal-connection presets for the PCB stator. No Angular / DI deps.
// Each style sizes the coil in/out terminal pad and its drilled hole.

export type TerminalStyle = 'solder' | 'wire' | 'screw';

export interface TerminalDims {
  padMm: number;   // copper pad diameter
  holeMm: number;  // plated drill diameter
}

export const TERMINAL_STYLES: Record<TerminalStyle, TerminalDims> = {
  solder: { padMm: 1.5, holeMm: 0.8 },   // current behaviour (default)
  wire:   { padMm: 2.0, holeMm: 1.2 },   // thicker wire
  screw:  { padMm: 4.0, holeMm: 2.2 },   // M2 screw clearance
};
